import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { environment } from '@/environments/environment';

export interface AuthUser {
  id: string;
  nombre: string;
  email: string;
  rol: string;
}

interface LoginResponse {
  data: {
    access_token: string;
    user: AuthUser;
  };
}

const TOKEN_KEY = 'hotel_token';
const USER_KEY = 'hotel_user';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);

  private _token = signal<string | null>(localStorage.getItem(TOKEN_KEY));
  private _usuario = signal<AuthUser | null>(
    JSON.parse(localStorage.getItem(USER_KEY) ?? 'null')
  );

  readonly token = this._token.asReadonly();
  readonly usuario = this._usuario.asReadonly();
  readonly isAuthenticated = () => !!this._token();

  login(email: string, password: string) {
    return this.http
      .post<LoginResponse>(`${environment.apiUrl}/auth/login`, { email, password })
      .pipe(
        tap((res) => {
          const { access_token, user } = res.data;
          localStorage.setItem(TOKEN_KEY, access_token);
          localStorage.setItem(USER_KEY, JSON.stringify(user));
          this._token.set(access_token);
          this._usuario.set(user);
        })
      );
  }

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    this._token.set(null);
    this._usuario.set(null);
    this.router.navigateByUrl('/auth/sign-in');
  }

  getToken(): string | null {
    return this._token();
  }
}
